import { baseColors } from '@groupby/ui-components';
export const getColor = (disabled, colour) => (disabled ? baseColors.disabled : colour || '');
export default getColor;
